var exports = {
  "k": "xfd349460--bb54f7--container",
};

module.exports = exports;
